import React from 'react';
import { InputGroup, Input, Button } from 'reactstrap';

               
const SearchBox = ({changeValue, text, ...props}) =>  (
  <InputGroup>
    <div className="input-group-prepend">
      <span className="input-group-text">
        <i className="fa fa-search"></i>
      </span>
    </div>

    <Input 
      type="text"
      placeholder="Search something"
      value={text}
      onChange={(e) => changeValue(e.target.value)}
    />
  </InputGroup>
)

export default SearchBox;